function initMoxFaq() {
  document.querySelectorAll('.mox-faq__cat-panel').forEach((panel) => {
    if (panel.dataset.moxFaqBound) return;
    panel.dataset.moxFaqBound = 'true';

    panel.addEventListener('toggle', (event) => {
      if (event.target.tagName !== 'DETAILS' || !event.target.open) return;
      panel.querySelectorAll('details[open]').forEach((details) => {
        if (details !== event.target) details.open = false;
      });
    }, true);
  });

  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('.mox-faq__cat-panel details[open]').forEach((details) => {
      details.open = false;
    });
  }
}

initMoxFaq();
document.addEventListener('shopify:section:load', initMoxFaq);

